export default __webpack_public_path__ + "static/media/button-cancel.adefa5ba.svg";